import { render, staticRenderFns } from "./allhis.vue?vue&type=template&id=0d10f330&scoped=true"
import script from "./allhis.vue?vue&type=script&lang=js"
export * from "./allhis.vue?vue&type=script&lang=js"
import style0 from "./allhis.vue?vue&type=style&index=0&id=0d10f330&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d10f330",
  null
  
)

export default component.exports